(ns common.db.coeffects.namespace-values
  (:require [re-frame.core :as rf]))

(defn namespace-values-cofx
  "Extract values from namespace.

    Example:

    ```clojure
    (deref re-frame.db/app-db)
    => {:sample {:foo \"foo\" :bar \"bar\"}}

    (rf/reg-event-fx :sample-event
      [(rf/inject-cofx :namespace-values :sample)]
      (fn [{:sample/keys [foo bar]}]
         ...))
    ```"
  [cofx namespace]
  (let [values (get-in (:db cofx) [namespace])
        r (fn [m k v]
            (assoc m (keyword namespace k) v))]
    (reduce-kv r cofx values)))

(rf/reg-cofx :namespace-values namespace-values-cofx)
